<template>
  <div class="bedankt-page-container">
    <div class="container">
      <div class="bedankt-content">
        <div class="success-icon">
          <i class="fas fa-check-circle"></i>
        </div>
        
        <h1>Bedankt voor uw inschrijving!</h1>
        
        <div class="message-content">
          <p class="main-message">
            Welkom bij <strong>Tandzorg Gestel</strong>! Uw inschrijving is succesvol ontvangen.
          </p>
          
          <div class="next-steps">
            <h3>Wat gebeurt er nu?</h3>
            <div class="steps-grid">
              <div class="step">
                <div class="step-number">1</div>
                <div class="step-content">
                  <h4>Bevestiging</h4>
                  <p>U ontvangt binnen 24 uur een bevestiging per e-mail</p>
                </div>
              </div>
              
              <div class="step">
                <div class="step-number">2</div>
                <div class="step-content">
                  <h4>Contact</h4>
                  <p>Wij nemen contact met u op voor uw eerste afspraak</p>
                </div>
              </div>
              
              <div class="step">
                <div class="step-number">3</div>
                <div class="step-content">
                  <h4>Kennismaking</h4>
                  <p>Tijdens uw eerste bezoek maken wij kennis en voeren een mondonderzoek uit</p>
                </div>
              </div>
            </div>
          </div>
          
          <div class="important-info">
            <h3>Belangrijk om mee te nemen</h3>
            <ul class="checklist">
              <li>✓ Geldig legitimatiebewijs</li>
              <li>✓ Zorgverzekeringspasje</li>
              <li>✓ Eventuele medicijnenlijst</li>
              <li>✓ Oude tandartsgegevens (indien van toepassing)</li>
            </ul>
          </div>
          
          <div class="contact-section">
            <h3>Heeft u nog vragen?</h3>
            <div class="contact-methods">
              <div class="contact-method">
                <i class="fas fa-phone"></i>
                <div>
                  <strong><a href="tel:+31735515644" class="contact-link">073 551 5644</a></strong>
                  <p>Ma-Do: 08:15-17:00</p>
                </div>
              </div>
              
              <div class="contact-method">
                <i class="fas fa-envelope"></i>
                <div>
                  <strong><a href="mailto:info@tandzorggestel.nl" class="contact-link">info@tandzorggestel.nl</a></strong>
                  <p>Wij reageren binnen 24 uur</p>
                </div>
              </div>
            </div>
          </div>
          
          <div class="action-buttons">
            <router-link to="/" class="btn btn-primary">Terug naar home</router-link>
            <router-link to="/afspraak-maken" class="btn btn-secondary">Afspraak maken</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Bedankt",
  mounted() {
    document.title = "Bedankt voor uw inschrijving | Tandzorg Gestel"
    document.querySelector('meta[name="description"]').setAttribute("content", "Bedankt voor uw inschrijving bij Tandzorg Gestel. Wij nemen spoedig contact met u op voor uw eerste afspraak.");
    this.$store.commit('updateActivePage', 'Bedankt')
    
    // Scroll naar top
    window.scrollTo(0, 0)
    
    // Voeg animatie toe
    setTimeout(() => {
      const content = document.querySelector('.bedankt-content')
      if (content) {
        content.classList.add('animate-in')
      }
    }, 100)
  }
}
</script>

<style scoped>
.bedankt-page-container {
  margin-top: 88px;
  min-height: calc(100vh - 88px);
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: 4rem 0;
}

.bedankt-content {
  max-width: 800px;
  margin: 0 auto;
  background: white;
  border-radius: 16px;
  box-shadow: 0 20px 40px rgba(0,0,0,0.1);
  padding: 4rem;
  text-align: center;
  opacity: 0;
  transform: translateY(30px);
  transition: all 0.8s ease;
}

.bedankt-content.animate-in {
  opacity: 1;
  transform: translateY(0);
}

.success-icon {
  font-size: 6rem;
  color: #28a745;
  margin-bottom: 2rem;
}

.success-icon i {
  animation: scaleIn 0.6s ease-out 0.3s both;
}

@keyframes scaleIn {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

h1 {
  color: var(--blue);
  font-size: 3.2rem;
  margin-bottom: 2rem;
  font-weight: 600;
}

.main-message {
  font-size: 1.8rem;
  color: #495057;
  margin-bottom: 3rem;
  line-height: 1.6;
}

.next-steps {
  margin-bottom: 3rem;
  text-align: left;
}

.next-steps h3 {
  color: var(--blue);
  font-size: 2.2rem;
  margin-bottom: 2rem;
  text-align: center;
}

.steps-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 2rem;
  margin-bottom: 2rem;
}

.step {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
}

.step-number {
  background: var(--blue);
  color: white;
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 1.4rem;
  flex-shrink: 0;
}

.step-content h4 {
  color: var(--blue);
  margin-bottom: 0.5rem;
  font-size: 1.6rem;
}

.step-content p {
  color: #6c757d;
  font-size: 1.4rem;
  line-height: 1.4;
}

.important-info {
  background: #f8f9fa;
  padding: 2rem;
  border-radius: 8px;
  margin-bottom: 3rem;
  text-align: left;
}

.important-info h3 {
  color: var(--blue);
  font-size: 2rem;
  margin-bottom: 1.5rem;
  text-align: center;
}

.checklist {
  list-style: none;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1rem;
}

.checklist li {
  font-size: 1.5rem;
  color: #495057;
  padding: 0.5rem 0;
}

.contact-section {
  margin-bottom: 3rem;
}

.contact-section h3 {
  color: var(--blue);
  font-size: 2.2rem;
  margin-bottom: 2rem;
}

.contact-methods {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
}

.contact-method {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  padding: 1.5rem;
  background: #f8f9fa;
  border-radius: 8px;
  text-align: left;
}

.contact-method i {
  font-size: 2.4rem;
  color: var(--blue);
}

.contact-method strong {
  font-size: 1.6rem;
  color: var(--blue);
  display: block;
  margin-bottom: 0.5rem;
}

.contact-method p {
  font-size: 1.3rem;
  color: #6c757d;
  margin: 0;
}

.action-buttons {
  display: flex;
  gap: 1.5rem;
  justify-content: center;
  flex-wrap: wrap;
}

.btn {
  padding: 1.2rem 2.5rem;
  border-radius: 8px;
  text-decoration: none;
  font-size: 1.6rem;
  font-weight: 600;
  transition: all 0.3s ease;
  display: inline-block;
}

.btn-primary {
  background: var(--blue);
  color: white;
}

.btn-primary:hover {
  background: #0056b3;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.2);
}

.btn-secondary {
  background: transparent;
  color: var(--blue);
  border: 2px solid var(--blue);
}

.btn-secondary:hover {
  background: var(--blue);
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.2);
}

/* Responsive design */
@media (max-width: 768px) {
  .bedankt-page-container {
    margin-top: 55px;
    padding: 2rem 1rem;
  }
  
  .bedankt-content {
    padding: 2rem;
  }
  
  h1 {
    font-size: 2.4rem;
  }
  
  .main-message {
    font-size: 1.6rem;
  }
  
  .steps-grid {
    grid-template-columns: 1fr;
  }
  
  .action-buttons {
    flex-direction: column;
  }
  
  .btn {
    width: 100%;
    text-align: center;
  }
}
</style>
